import { render, staticRenderFns } from "./ProductModel-Delivered.vue?vue&type=template&id=5d7804c6&"
import script from "./ProductModel-Delivered.vue?vue&type=script&lang=js&"
export * from "./ProductModel-Delivered.vue?vue&type=script&lang=js&"
import style0 from "./ProductModel-Delivered.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports